import { NgModule } from '@angular/core';

import {
  INTERNAL_ONTIMIZE_MODULES_EXPORTED,
  INTERNAL_ONTIMIZE_MODULES
} from './ontimize/config/o-modules';

export { ONTIMIZE_MODULES } from './ontimize/config/o-modules';
export { ONTIMIZE_PROVIDERS } from './ontimize/config/o-providers';

export * from './ontimize/config/app-config';
export * from './ontimize/MainLauncher';
export * from './ontimize/pipes';
export * from './ontimize/services';
export * from './ontimize/decorators';
export * from './ontimize/components';
export * from './ontimize/layouts';
export * from './ontimize/utils';
export * from './ontimize/shared';
export * from './ontimize/validators/o-validators';

import { ODialogComponent } from './ontimize/components';


export class OntimizeWebModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: INTERNAL_ONTIMIZE_MODULES,
  exports: INTERNAL_ONTIMIZE_MODULES_EXPORTED,
  entryComponents: [
    ODialogComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
